import { fetchLoggin, fetchPasswordValidity, fetchGetBody } from "../../helpers/fetch";
import { types } from "../../types/types";
import { calcMD5 } from "../../helpers/md5";
import { ShowMessage } from "../../componets/showMessage/ShowMessage";
import bcryptjs from "bcryptjs";

export const startLogin = (username, password, captcha, code, setShowLoader, TexTranslate, intl, app, setShowTimer, setLoadingTime, history,loginCore, processResponseLoginCore, closeSessionCore ) => {
    
    return async (dispatch) => {

        let salt = await bcryptjs.genSalt(12)
        let selectLanguage = document.getElementById("selectLanguage");
        
        const passwordBcrypt = await bcryptjs.hash (password, app.salt);
        let passEncr = code != undefined ? password: calcMD5(password);        
        let jsonDataAuth;
        let loginResponse;
        let msgProcessLoginCore;

        let data = {
            username,
            "psxm": passwordBcrypt,
            "ctlx": captcha,
            "mcin": passEncr
        };
        if(code !== undefined){
            data["code"] = code;
        }
        data["language"] = selectLanguage.value || 'es'
        let resp = await fetchLoggin(data, 'POST', app);

        if(resp.ok){
                data.password = passwordBcrypt;
                data.passwordBcrypt = true;
       }

        let waitTimeFromFirst;
        let body;

        if(!resp.ok && resp.status === 400){
            try {
                body = await resp.json();
                waitTimeFromFirst = body?.waitTime ?? body?.bloqueo;
            } catch (e) {
                body = {};
            }
            if (waitTimeFromFirst !== undefined && waitTimeFromFirst !== null) {
                setShowLoader(false);
                setLoadingTime(waitTimeFromFirst ?? 60);
                setShowTimer(true);
                return;
            }
           
        }

        if (body === undefined) {
            try {
                body = await resp.json();
            } catch (e) {
                body = {};
            }
        }

        const waitTimeValue = body?.waitTime ?? waitTimeFromFirst ?? body?.bloqueo;
        const hasWaitTime = waitTimeValue !== undefined && waitTimeValue !== null;

        if (hasWaitTime && !body?.access_token) {
            setShowLoader(false);
            setLoadingTime(waitTimeValue ?? 60);
            setShowTimer(true);
            return;
        }

        if(!resp.ok && resp.status === 401 ) {
            if (body.error_description === "Request.Code.Auth" 
                || body.error_description === "Invalid.Code.Auth") {
                setShowLoader(false);
                data.password = passwordBcrypt;
                data.passwordBcrypt = true;
                dispatch(loginCode({ loginData: { ...data } }));
                history.push(`/${app.baseName}/codeLogin.html`, {});
                return;
            } else if (body.error_description === "Bloqueo") {
                setShowLoader(false);
                setLoadingTime(waitTimeValue ?? 60);
                setShowTimer(true);
            } else if (body.error_description === "Expired") {
                setShowLoader(false);
                dispatch(login({expired: true}));
                history.push(`/${app.baseName}/changePassMandatory.html`, {});
            }  else {
                setShowLoader(false);
                if (!hasWaitTime) {
                    ShowMessage(
                        {
                            title: TexTranslate(intl, "general.Warning", "general.Warning"),
                            message: TexTranslate(intl, "login.incorrect username or password", "login.incorrect username or password"),
                            typeMessage: "warning",
                            showCancelButton: false,
                            intl
                        }
                    )
                }
                dispatch(checkingFinish());
                setLoadingTime(waitTimeValue ?? 60);
                setShowTimer(true);
            }
        } else if (body.access_token ) {

                const respBody = await fetchGetBody(app, body.access_token);
                const tokenJson = respBody.userData;
            
                if (tokenJson) {
                    jsonDataAuth = (tokenJson.type_user).toLowerCase();

                    if (jsonDataAuth === 'supplier') {
                        let value = {
                            token : body.access_token,
                            idioma : selectLanguage.value
                        }
                        loginResponse = await loginCore({"value" : value});

                        if (loginResponse?.success) {
                            sessionStorage.setItem('userRedirect', body.access_token);
                            sessionStorage.setItem('login', tokenJson.user_name);
                            sessionStorage.setItem('email', tokenJson.email);
                            sessionStorage.setItem('idioma', selectLanguage.value);
                            sessionStorage.setItem('token.type', jsonDataAuth);
                            dispatch(login(body));
                        } else {
                            msgProcessLoginCore = processResponseLoginCore({
                                "msg" : loginResponse.msg,
                                "msgParams" : loginResponse,
                                "TexTranslate" : TexTranslate,
                                "intl" : intl
                            });
                            setShowLoader(false);

                            if(msgProcessLoginCore) {
                                ShowMessage(
                                    {
                                        title: TexTranslate(intl, "general.Warning", "general.Warning"),
                                        message: msgProcessLoginCore,
                                        typeMessage: "warning",
                                        showCancelButton: false,
                                        intl
                                    }
                                );
                            } else {
                                ShowMessage(
                                    {
                                        title: TexTranslate(intl, "general.Warning", "general.Warning"),
                                        message: TexTranslate(intl, "login.incorrect username or password", "login.incorrect username or password"),
                                        typeMessage: "warning",
                                        showCancelButton: false,
                                        intl
                                    }
                                );
                            }
                            dispatch(checkingFinish());
                        }
                        
                    } else if (jsonDataAuth === 'admin' || jsonDataAuth === 'funder') {
                        if(jsonDataAuth === 'admin'){
                            let value = {
                                token : body.access_token,
                                idioma : selectLanguage.value || 'es'
                            }
                            loginResponse = await loginCore({"value" : value});
    
                            if (loginResponse?.success) {
                                sessionStorage.setItem('userRedirect', body.access_token);
                                sessionStorage.setItem('idioma', selectLanguage.value);
                                sessionStorage.setItem('token.type', jsonDataAuth);
                                dispatch(login(body));
                                return;
                            } else {
                                msgProcessLoginCore = processResponseLoginCore({
                                    "msg" : loginResponse.msg,
                                    "msgParams" : loginResponse,
                                    "TexTranslate" : TexTranslate,
                                    "intl" : intl
                                });
                                setShowLoader(false);
    
                                if(msgProcessLoginCore) {
                                    ShowMessage(
                                        {
                                            title: TexTranslate(intl, "general.Warning", "general.Warning"),
                                            message: msgProcessLoginCore,
                                            typeMessage: "warning",
                                            showCancelButton: false,
                                            intl
                                        }
                                    );
                                } else {
                                    ShowMessage(
                                        {
                                            title: TexTranslate(intl, "general.Warning", "general.Warning"),
                                            message: TexTranslate(intl, "login.incorrect username or password", "login.incorrect username or password"),
                                            typeMessage: "warning",
                                            showCancelButton: false,
                                            intl
                                        }
                                    );
                                }
                                dispatch(checkingFinish());
                                return;
                            }
                        }

                        let value = {
                            token : body.access_token,
                            idioma : selectLanguage.value
                        }
                        loginResponse = await loginCore({"value" : value});

                        if (loginResponse?.success) {
                            sessionStorage.setItem('token', body.access_token);
                            sessionStorage.setItem('token.type', jsonDataAuth);
                            sessionStorage.setItem('idioma', selectLanguage.value);
                            if (jsonDataAuth === "funder") {
                                window.location.href =`${app.apiCore}/Funder.jsp?lang_user=${selectLanguage.value || 'es'}`
                            }
                        } else {
                            msgProcessLoginCore = processResponseLoginCore({
                                "msg" : loginResponse.msg,
                                "msgParams" : loginResponse,
                                "TexTranslate" : TexTranslate,
                                "intl" : intl
                            });
                            setShowLoader(false);
                            if(msgProcessLoginCore) {
                                ShowMessage(
                                    {
                                        title: TexTranslate(intl, "general.Warning", "general.Warning"),
                                        message: msgProcessLoginCore,
                                        typeMessage: "warning",
                                        showCancelButton: false,
                                        intl
                                    }
                                );
                            } else {
                                ShowMessage(
                                    {
                                        title: TexTranslate(intl, "general.Warning", "general.Warning"),
                                        message: TexTranslate(intl, "login.incorrect username or password", "login.incorrect username or password"),
                                        typeMessage: "warning",
                                        showCancelButton: false,
                                        intl
                                    }
                                );
                            }
                            dispatch(checkingFinish());
                        }
                    } else {
                        setShowLoader(false);
                        console.log("typeUser.error");
                    }
                } else {
                    setShowLoader(false);
                }

        } else {
            setShowLoader(false);
            if (!hasWaitTime) {
                ShowMessage(
                    {
                        title: TexTranslate(intl, "general.Warning", "general.Warning"),
                        message: TexTranslate(intl, "login.incorrect username or password", "login.incorrect username or password"),
                        typeMessage: "warning",
                        showCancelButton: false,
                        intl
                    }
                )
            }
            dispatch(checkingFinish());
            setLoadingTime(waitTimeValue ?? 60);
            setShowTimer(true);
        }

    }

}

export const continueLoginCode = (loginData, setShowLoader, TexTranslate, intl, app, setShowTimer, setLoadingTime, history,loginCore, processResponseLoginCore ) => {
    return async (dispatch) => {
        if (loginData.error_description === 'Invalid.Code.Auth') {
            setShowLoader(false);
           ShowMessage(
                {
                    title: TexTranslate(intl, "general.Warning", "general.Warning"),
                    message: TexTranslate(intl, "login.access_code.incorrect_msg", "login.access_code.incorrect_msg"),
                    typeMessage: "warning",
                    showCancelButton: false,
                    intl
                }
            );
            dispatch(checkingFinish());
        } else {
            let msgProcessLoginCore;
            const value = {
                token : loginData.access_token,
                idioma : loginData.language,
            }
            const loginResponse = await loginCore({"value" : value});
    
            if(loginResponse?.success){
    
                const respBody = await fetchGetBody(app, loginData.access_token);
                const tokenJson = respBody.userData;            
    
                if(tokenJson) {
                    if (tokenJson.type_user.toLowerCase() === "admin") {
                        sessionStorage.setItem('userRedirect', loginData.access_token);
                        sessionStorage.setItem('idioma', loginData.language);
                        sessionStorage.setItem('token.type', tokenJson.type_user.toLowerCase());
                        const authBody = {
                            "access_token" : loginData.access_token,
                            "loginData" : undefined
                        }
                        dispatch(login(authBody));
                        return;
                    }
    
                    sessionStorage.setItem('token', loginData.access_token);
                    sessionStorage.setItem('token.type', tokenJson.type);
                    if (tokenJson.type_user.toLowerCase() === "funder") {
                        window.location.href =`${app.apiCore}/Funder.jsp?lang_user=${loginData.language || 'es'}`
                    }
                } else {
                    setShowLoader(false);
                }
            } else {
                msgProcessLoginCore = processResponseLoginCore({
                    "msg" : loginResponse.msg,
                    "msgParams" : loginResponse,
                    "TexTranslate" : TexTranslate,
                    "intl" : intl
                });
                setShowLoader(false);
                if(msgProcessLoginCore) {
                    ShowMessage(
                        {
                            title: TexTranslate(intl, "general.Warning", "general.Warning"),
                            message: msgProcessLoginCore,
                            typeMessage: "warning",
                            showCancelButton: false,
                            intl
                        }
                    );
                } else {
                    ShowMessage(
                        {
                            title: TexTranslate(intl, "general.Warning", "general.Warning"),
                            message: TexTranslate(intl, "login.incorrect username or password", "login.incorrect username or password"),
                            typeMessage: "warning",
                            showCancelButton: false,
                            intl
                        }
                    );
                }
                dispatch(checkingFinish());
            }
        }
    }
}

export const startLoginSSO = ({
    paramObj,
    TexTranslate,
    intl,
    loginSignOn,
    setLoad,
    setTexto,
    setDataSign
}) => {

    return async () => {
        const search = paramObj.search;
        delete paramObj.search;
        const { "response": respSSO, body } = await loginSignOn(paramObj);

        if (respSSO) {

            if (respSSO.ok && body && body.success) {

                if (body.access_token) {

                    setTexto(TexTranslate(intl, "login.Logging in, please wait", "login.Logging in, please wait"));
                    setDataSign({ respSSO, body, "msg": "tk.ok" });
                } else {
                    setDataSign({ "msg": "invalid" });
                    setLoad(false);
                }

            } else if (!respSSO.ok && respSSO.status === 401) {
                if (body.error_description === "Request.Code.Auth"
                    || body.error_description === "Invalid.Code.Auth") {
                    paramObj.search = search;
                    if (paramObj.search.indexOf("code=") >= 0) {
                        paramObj.failedCode = true;
                    }
                    const dataLoginCodeSSO = loginCode(
                        {
                            "loginData":
                            {
                                typeLog: "SSO",
                                ...paramObj
                            }
                        }
                    );
                    setDataSign({ dataLoginCodeSSO, "msg": "code" });
                } else {
                    setLoad(false);
                    setDataSign({ "msg": "invalid" });
                }
            } else {
                setDataSign({ "msg": "error" });
                setLoad(false);
            }
        } else {
            setDataSign({ "msg": "error" });
            setLoad(false);
        }

    }

}

export const processLoginSSO = ({
    respSSO,
    body,
    TexTranslate,
    intl,
    app,
    history,
    loginCore,
    loginSignOn,
    processResponseLoginCore,
    setLoad,
    setTexto,
    setDataSign
}) => {

    return async (dispatch) => {

        if (respSSO.ok && body && body.success) {

            if (body.access_token) {

                const idiomaParam = body.idioma ? body.idioma : 'es';
                const respBody = await fetchGetBody(app, body.access_token);
                const tokenJson = respBody.userData;

                if (tokenJson) {
                    const jsonDataAuth = (tokenJson.type_user).toLowerCase();
                    const value = {
                        token: body.access_token,
                        idioma: idiomaParam
                    }
                    const dataLoginCore = { "value": value };
                    if (body.keyClient) {
                        dataLoginCore.keyClient = body.keyClient;
                    }
                    const loginResponse = await loginCore(dataLoginCore);

                    if (loginResponse && loginResponse.success) {

                        if (jsonDataAuth === 'supplier') {
                            sessionStorage.setItem('userRedirect', body.access_token);
                            sessionStorage.setItem('login', tokenJson.user_name);
                            sessionStorage.setItem('email', tokenJson.email);
                            sessionStorage.setItem('idioma', idiomaParam);
                            sessionStorage.setItem('token.type', jsonDataAuth);
                            if (body.keyClient) {
                                window.location.replace(`${app.apiCore}/Supplier.jsp?lang_user=${idiomaParam}#`);
                            } else {
                                dispatch(login(body));
                            }
                        } else if (jsonDataAuth === 'admin') {
                            sessionStorage.setItem('userRedirect', body.access_token);
                            sessionStorage.setItem('idioma', idiomaParam);
                            sessionStorage.setItem('token.type', jsonDataAuth);
                            if (body.keyClient) {
                                window.location.replace(`${app.apiCore}/Supplier.jsp?lang_user=${idiomaParam}#`);
                            }
                            else {
                                dispatch(login(body));
                            }
                        } else if (jsonDataAuth === 'funder') {
                            sessionStorage.setItem('token', body.access_token);
                            sessionStorage.setItem('token.type', jsonDataAuth);
                            sessionStorage.setItem('idioma', idiomaParam);
                            window.location.href = `${app.apiCore}/Funder.jsp?lang_user=${idiomaParam}`
                        } else {
                            setLoad(false);
                            console.log("typeUser.error");
                        }
                    } else {
                        const msgProcessLoginCore = processResponseLoginCore({
                            "msg": loginResponse.msg,
                            "msgParams": loginResponse,
                            "TexTranslate": TexTranslate,
                            "intl": intl
                        });
                        setLoad(false);

                        if (msgProcessLoginCore) {
                            setDataSign({ "msg": msgProcessLoginCore });
                        } else {
                            setDataSign({ "msg": "invalid" });
                        }
                    }
                } else {
                    setLoad(false);
                    dispatch(checkingFinish());
                }

            } else {
                setLoad(false);
                dispatch(checkingFinish());
            }
        } else {
            setLoad(false);
            dispatch(checkingFinish());
        }
    }

}

const checkingFinish = () => ({
    type: types.authCheckingFinish
})

const login = (user) => ({
    type: types.authLogin,
    payload: user
})

const loginCode = (data) => ({
    type: types.authLoginCode,
    payload: data
})
